import { oneOf, Select } from '@platform/design-system';

export type ChoiceFieldProps<Value extends string> = {
  label: string;
  value: Value;
  choices: readonly Value[];
  labelOf: (value: Value) => string;
  onChange: (value: Value) => void;
};

export const ChoiceField = <Value extends string>({
  label,
  value,
  choices,
  labelOf,
  onChange,
}: ChoiceFieldProps<Value>) => (
  <Select
    label={label}
    value={value}
    options={choices.map((choice) => ({ value: choice, label: labelOf(choice) }))}
    onChange={(event) => {
      onChange(oneOf(choices, event.target.value, value));
    }}
  />
);
